export default "__VITE_ASSET__$jJ2uCQa__"